import { useQuery } from '@tanstack/react-query';
import { type MyMemberInfo, memberInfoKey, requestMyMemberInfo } from './memberInfoApi';

/** The two fields the Contact Us modal seeds from the member's own session. */
export interface MemberContactPrefill {
  name: string | undefined;
  email: string | undefined;
}

/**
 * `undefined` rather than `''` for a missing value: `ContactUsModal`'s props are optional, and an
 * empty string would seed the field with a value the member then has to clear.
 */
export function mapToMemberContactPrefill(member: MyMemberInfo): MemberContactPrefill {
  const name = [member?.firstName, member?.lastName].filter(Boolean).join(' ');
  return {
    name: name || undefined,
    email: member?.email || undefined,
  };
}

/**
 * Name and email for the Contact Us modal's prefill, read from the shared `myMemberInfo`
 * query/cache — same key as {@link useMemberCardIdentity} and the Payments hooks, only the `select`
 * differs, so opening the modal fires no second request.
 */
export function useMemberContactPrefill() {
  return useQuery({
    queryKey: memberInfoKey,
    queryFn: requestMyMemberInfo,
    select: mapToMemberContactPrefill,
  });
}
